import { createContext, useContext, useState } from "react";

interface FloatingWidgetsContextType {
  isChecklistVisible: boolean;
  setChecklistVisible: (visible: boolean) => void;
}

const FloatingWidgetsContext = createContext<FloatingWidgetsContextType | null>(
  null,
);

export function useFloatingWidgets() {
  const context = useContext(FloatingWidgetsContext);
  if (!context) {
    throw new Error(
      "useFloatingWidgets must be used within FloatingWidgetsProvider",
    );
  }
  return context;
}

export function FloatingWidgets() {
  const [isChecklistVisible, setChecklistVisible] = useState(true);

  return (
    <FloatingWidgetsContext.Provider
      value={{
        isChecklistVisible,
        setChecklistVisible,
      }}
    >
      <div className="fixed bottom-0 right-0 z-[999] pointer-events-none">
        <div className="flex flex-col items-end gap-3 p-6 pointer-events-auto">
        </div>
      </div>
    </FloatingWidgetsContext.Provider>
  );
}
